import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  Flex,
  Spinner,
  Select,
  Icon,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { FaCircle } from "react-icons/fa";

import moment from "moment";
import SalesListAPI from "../../../../services/SalesListApi";
import { VARIANT, WHITE } from "../../../../constants/colors";
import { dateForListWithHours } from "../../../../constants/dataFormat";
import { CaptionFormater } from "../../../../defaultFunctions/formaters";
import Pagination from "../../../../defaultComponents/pagination";
import ModalSalesListDetail from "../../listaDeVendas/components/modalSaleListDetail";
import CardImageList from "../../listaDeVendas/defaultComponent/tableCardImage";
import { useRecoilState } from "recoil";
import { customColors } from "../../../../atoms/customColors";

interface objetoSalesList {
  bandeira: string;
  bandeiraCartao: string;
  cartaoFim: string;
  cartaoInicio: string;
  clienteNome: string;
  cnpj: string;
  codigoAutorizacao: string;
  codigoAutorizacaoId: string;
  codigoNsu: string;
  dataAtualizacao: string;
  dataCriacao: string;
  dataEstorno: string;
  dataExpiracao: string;
  dataPagamento: any;
  dataReversao: string;
  descricaoEC: string;
  id: number;
  idBandeira: number;
  idCustomer: string;
  idPagamento: string;
  idPos: string;
  idProduto: number;
  idProjeto: number;
  idProvider: number;
  idSeller: string;
  idStatus: number;
  idTransacao: string;
  isCnpj: boolean;
  isCreditCard: boolean;
  modoPagamento: string;
  moeda: string;
  nome: string;
  nomeFantasia: string;
  nomeModoPgto: string;
  nomeProduto: string;
  nomeProjeto: string;
  nomeProvedor: string;
  numeroTransacao: string;
  parcelas: number;
  qrCodePIX: any;
  razaoSocial: string;
  reference_id: any;
  serialPOS: string;
  sobrenome: string;
  status: string;
  statusTransacao: string;
  taxaCliente: number;
  taxaPlano: number;
  taxaZoop: number;
  taxas: number;
  urlBoleto: string;
  urlPIX: string;
  valor: number;
  valorLiquido: number;
  valorOriginal: number;
}

export default function TableSalesListTransacoes({
  search,
  dataInicio,
  dataFim,
  filtros,
  idCustomer,
}: any) {
  const [salesList, setSalesList] = useState(Array<objetoSalesList>);
  const [itemDetails, setItemDetails] = useState<objetoSalesList>();
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(15);
  const [pages, setPages] = useState(1);
  const [isOpen, setIsOpen] = useState(false);

  const colors = useRecoilState(customColors)[0];

  async function getSalesList() {
    //mudar
    try {
      setLoading(true);
      if (!search) {
        const response = await SalesListAPI.getSalesListVendasRecorrentes(
          currentPage,
          pageSize,
          dataInicio,
          dataFim,
          search,
          filtros.clientFilter,
          filtros.minValueFilter,
          filtros.maxValueFilter,
          filtros.statusFilter,
          filtros.saleTypeFilter,
          idCustomer
        );
        setSalesList(response.data);
        setPages(
          Math.ceil(Number(response.headers.totalamountofrecords) / pageSize)
        );
      } else {
        const response = await SalesListAPI.getSalesListVendasRecorrentes(
          currentPage,
          pageSize,
          dataInicio,
          dataFim,
          search,
          filtros.clientFilter,
          filtros.minValueFilter,
          filtros.maxValueFilter,
          filtros.statusFilter,
          filtros.saleTypeFilter,
          idCustomer
        );
        setSalesList(response.data);
        const lenght = response.data.length;
        setPages(Math.ceil(lenght / pageSize));
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  }
  const onChangeSize = (e: any) => {
    setPageSize(e.target.value);
    setCurrentPage(1);
  };
  useEffect(() => {
    if (currentPage > pages) {
      setCurrentPage(1);
      getSalesList();
    }
  }, [pages]);
  useEffect(() => {
    getSalesList();
  }, [
    search,
    currentPage,
    pageSize,
    filtros.statusFilter,
    filtros.saleTypeFilter,
    filtros.clientFilter,
    filtros.initialDateFilter,
    filtros.finalDateFilter,
    filtros.minValueFilter,
    filtros.maxValueFilter,
  ]);
  return (
    <Flex
      width={"82vw"}
      height={"80vh"}
      mt={"0.1%"}
      mx="auto"
      flexDir={"column"}
    >
      {!loading ? (
        <TableContainer width={"100%"} overflowY="scroll">
          <Table variant="striped">
            <Thead h="60px" zIndex={1} position="sticky" top="0">
              <Tr>
                <Th
                  borderRadius={"8px 0 0 8px"}
                  bgColor={colors.BLUEMONEDDBUTTONS}
                  color={colors.WHITE}
                >
                  Data da Venda
                </Th>
                <Th
                  bgColor={colors.BLUEMONEDDBUTTONS}
                  color={colors.WHITE}
                >
                  Status
                </Th>
                <Th
                  bgColor={colors.BLUEMONEDDBUTTONS}
                  color={colors.WHITE}
                >
                  Estabelecimento
                </Th>
                <Th
                  bgColor={colors.BLUEMONEDDBUTTONS}
                  color={colors.WHITE}
                >
                  Nome do Pagador
                </Th>
                <Th
                  bgColor={colors.BLUEMONEDDBUTTONS}
                  color={colors.WHITE}
                >
                  ID de transação
                </Th>
                <Th
                  bgColor={colors.BLUEMONEDDBUTTONS}
                  color={colors.WHITE}
                >
                  Tipo de Venda
                </Th>
                <Th
                  borderRadius={"0 8px 8px 0"}
                  bgColor={colors.BLUEMONEDDBUTTONS}
                  color={colors.WHITE}
                >
                  Valor
                </Th>
              </Tr>
            </Thead>
            <Tbody>
              {salesList &&
                salesList.map((item, index) => {
                  return (
                    <Tr
                      key={index}
                      cursor="pointer"
                      onClick={() => {
                        setIsOpen(true);
                        setItemDetails(item);
                      }}
                    >
                      <Td fontSize={"0.8rem"}>
                        {moment(item.dataCriacao).format(dateForListWithHours)}
                      </Td>
                      <Td fontSize={"0.8rem"}>
                        <Flex flexDirection={"row"}>
                          {(item.status === "succeeded" && (
                            <>
                              <Icon mr={2} as={FaCircle} color={"green"} />{" "}
                              Sucesso
                            </>
                          )) ||
                            (item.status === "pending" && (
                              <>
                                <Icon mr={2} as={FaCircle} color={"yellow"} />{" "}
                                Pendente
                              </>
                            )) ||
                            (item.status === "failed" && (
                              <>
                                <Icon mr={2} as={FaCircle} color={"orange"} />{" "}
                                Falhou
                              </>
                            )) ||
                            (item.status === "new" && (
                              <>
                                <Icon mr={2} as={FaCircle} color={"gray"} />{" "}
                                Nova
                              </>
                            )) ||
                            (item.status === "charged_back" && (
                              <>
                                <Icon mr={2} as={FaCircle} color={"black"} />{" "}
                                ChargeBack{" "}
                              </>
                            )) ||
                            (item.status === "canceled" && (
                              <>
                                <Icon mr={2} as={FaCircle} color={"red"} />{" "}
                                Cancelado{" "}
                              </>
                            )) ||
                            (item.status === "reversed" && (
                              <>
                                <Icon mr={2} as={FaCircle} color={"purple"} />{" "}
                                Revertido{" "}
                              </>
                            )) ||
                            (item.status === "dispute" && (
                              <>
                                <Icon mr={2} as={FaCircle} color={"pink"} /> Em
                                Disputa{" "}
                              </>
                            ))}
                        </Flex>
                      </Td>
                      <Td fontSize={"0.8rem"}>
                        {item?.isCnpj === true
                          ? CaptionFormater(item.razaoSocial)
                          : `${CaptionFormater(item.nome)} ${CaptionFormater(
                            item.sobrenome
                          )}`}
                      </Td>
                      <Td fontSize={"0.8rem"}>
                        {item.clienteNome
                          ? CaptionFormater(item.clienteNome)
                          : ""}
                      </Td>

                      <Td fontSize={"0.8rem"}>{item.idTransacao}</Td>
                      <Td w={"fit-content"} fontSize={"0.8rem"}>
                        <CardImageList
                          key={index}
                          text={
                            item.bandeiraCartao
                              ? item.bandeiraCartao
                              : item.bandeira
                          }
                        >
                          {item.bandeiraCartao
                            ? item.bandeiraCartao
                            : item.bandeira}
                        </CardImageList>
                      </Td>
                      <Td fontSize={"0.8rem"}>
                        {item.valor.toLocaleString("pt-BR", {
                          style: "currency",
                          currency: "BRL",
                        })}
                      </Td>
                    </Tr>
                  );
                })}
            </Tbody>
          </Table>
        </TableContainer>
      ) : (
        <Flex
          w={"100%"}
          h={"85%"}
          justifyContent={"center"}
          alignItems={"center"}
        >
          <Spinner color={VARIANT} size={"lg"} />
        </Flex>
      )}
      <ModalSalesListDetail
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        item={itemDetails}
      />

      <Flex width={"100%"} justifyContent="center" mt={4} alignItems={"center"}>
        <Pagination
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          pages={pages}
          pageSize={pageSize}
        />
        <Select
          value={pageSize}
          onChange={onChangeSize}
          size="sm"
          ml={5}
          maxW="70px"
          borderRadius="6px"
        >
          <option key={5} value={5}>
            5
          </option>
          <option key={10} value={10}>
            10
          </option>
          <option key={15} value={15}>
            15
          </option>
          <option key={20} value={25}>
            25
          </option>
        </Select>
      </Flex>
    </Flex>
  );
}
